import { service } from "../service"


export const getAllCategory = async () => {
    let url = `/api/v1/get-all-category`

    return service
        .get(url)
        .then((res: any) => res)
        .catch((err: any) => err)
}

export const getDashboard = async () => {
    let url = `/api/v1/get-dashboard`

    return service
        .get(url)
        .then((res: any) => res)
        .catch((err: any) => err)
}

export const getItemsByCategory = async (params: any) => {
    let url = `/api/v1/get-collection-by-category`

    return service
        .post(url, params)
        .then((res: any) => res)
        .catch((err: any) => err)
}

export const search = async (params: any) => {
    let url = `/api/v1/search`;

    return service
        .post(url, params)
        .then((res: any) => res)
        .catch((err: any) => err)
}